<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月26日 11:04:02
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div>
        <div class="task-container">
            <el-image
            class="implement-image"
            :src="timePhoto"></el-image>
            <div class="task">{{task}}</div>
        </div>
        <div  class="footer">
            <template v-if="showType==1">
                <div :style="{'color':status==0?'#029FD1':'#F22D2E'}" class="time-message">
                    <div>{{status==0?'完成':status==1?'拒绝':status==2?'缺席':status==3?'没有必要':status==4?'未完成':status==5?'延期':'其他'}}-{{InputDate}}由{{userName}} {{Value}}</div>
                    <div class="remark">{{remark}}</div>
                </div>
            </template>
            <template v-else>
                <template v-if="oldStatus!==null">
                    <el-image
                    class="implement-small-image implement-image-liuyan"
                    :src="FRImg"></el-image>
                    <div :style="{'color':status==0?'#029FD1':'#F22D2E'}" class="time-message">
                        <div>于{{InputDate}}由{{userName}} {{Value}}</div>
                        <div v-if="remark" class="remark">{{remark}}</div>
                    </div>
                    <el-image
                    class="implement-image implement-image-caozuo"
                    @click="getHistory"
                    :src="hasHistoryRecords?jilu2:jilu1"></el-image>
                </template>
                <template v-else>
                    <div class="check-close">
                        <el-image
                        @click="check"
                        class="implement-all-check"
                        :src="finishImg"></el-image>
                        <el-image
                        @click="close"
                        class="implement-all-close"
                        :src="refuseImg"></el-image>
                    </div>
                    <div>
                        <el-image
                        class="implement-image implement-image-liuyan"
                        @click="setRemark"
                        :src="remarkImg"></el-image>
                        <el-image
                        class="implement-image implement-image-caozuo"
                        @click="getHistory"
                        :src="hasHistoryRecords?jilu1:jilu2"></el-image>
                    </div>
                </template>
            </template>
        </div>
       
    </div>
</template>

<script>
import timePhoto from '@/assets/imgs/time.png'
import jilu1 from '@/assets/imgs/icon-caozuo-jilu-1.png'
import jilu2 from '@/assets/imgs/icon-caozuo-jilu-2.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    obj:Object,
    //显示类型：1为历史记录，2为其他
    showType:{
        type:Number,
        default:2
    },
    oldStatus:{
        type:Number|null,
        default:null
    },
    //0为执行完成,1为拒绝执行，2缺席，3没有必要，4未完成
    status:{
        type:Number|null,
        default:0
    },
    task:String,
    time:String,
    remark:String,
    userName:String,
    InputDate:String,
    Value:String,
    hasHistoryRecords:Boolean

  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
      return {
          jilu1,
          jilu2,
          timePhoto,
          }
  },
  // 计算属性
  computed: {
    finishImg(){
        return this.status==0?require('@/assets/imgs/icon-zhuangtai-wancheng-2.png').default:require('@/assets/imgs/icon-zhuangtai-wancheng-1.png').default
    },
    refuseImg(){
        return !this.status?require('@/assets/imgs/icon-zhuangtai-weiwancheng-1.png').default:require('@/assets/imgs/icon-zhuangtai-weiwancheng-2.png').default
    },
    FRImg(){
        // return this.status==1?require('@/assets/imgs/icon-zhuangtai-weiwancheng-3.png').default:
        // this.status==2?require('@/assets/imgs/yanqi.png').default:this.status==3?require('@/assets/imgs/jujue.png').default:this.status==4?require('@/assets/imgs/quexi.png').default:
        // this.status==5?require('@/assets/imgs/meibiyao.png').default:require('@/assets/imgs/icon-zhuangtai-wancheng-3.png').default
        return this.status==0?require('@/assets/imgs/icon-zhuangtai-wancheng-3.png').default:
        this.status==1?require('@/assets/imgs/jujue.png').default:
        this.status==2?require('@/assets/imgs/quexi.png').default:
        this.status==3?require('@/assets/imgs/meibiyao.png').default:
        this.status==5?require('@/assets/imgs/yanqi.png').default:
        require('@/assets/imgs/icon-zhuangtai-weiwancheng-3.png').default
    },
    remarkImg(){
        return this.remark?require('@/assets/imgs/icon-caozuo-liuyan@2x.png').default:require('@/assets/imgs/icon-caozuo-liuyan-48@2x.png').default
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    check(){
        this.$emit('check',this.obj)
    },
    close(){
        this.$emit('close',this.obj)
    },
    setRemark(){
        this.$emit('setRemark',this.obj)
    },
    getHistory(){
        this.$emit('getHistory',this.obj)
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>
.task{
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    color: #029FD1;
    font-family: 'PingFang SC Medium';
}
.task-container{
    display: flex;
    margin-top: 14px;
    padding-bottom: 12px;
    align-items: center;
}
.check-close{
    display: flex;
}
.footer{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.time-message{
    flex: 1;
    text-align: left;
    font-size: 12px;
}
.remark{
    margin-top: 3px;
    font-size: 20px;
    color: #434649 !important;
}
.implement-image{
    margin-right: 3px;
}
.implement-image-liuyan{
    margin-right: 5px;
}
.implement-all-check{
    margin-right: 15px;
}
.implement-image,.implement-all-check,.implement-all-close{
    width: 24px;
    height: 24px;
}
.implement-small-image{
    width: 17px;
    height: 17px;
}

</style>



// WEBPACK FOOTER //
// src/common/implement-item-footer.vue